// extracted by mini-css-extract-plugin
module.exports = {"strokeMarketplaceColor":"IconKeys_strokeMarketplaceColor__2wa4g"};